import {Construtor} from './construtor';

export class PercentualStatus implements Construtor<PercentualStatus> {

  public descricaoStatusOcorrencia: string;
  public percentual: number;

  constructor(object?: any) {
    if (object !== undefined) {
      if (object instanceof (PercentualStatus)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(percentualStatus: any): void {
    this.descricaoStatusOcorrencia = percentualStatus.descricaoStatusOcorrencia;
    this.percentual = percentualStatus.percentual;
  }

  copyObject(percentualStatus: PercentualStatus): void {
    this.descricaoStatusOcorrencia = percentualStatus.descricaoStatusOcorrencia;
    this.percentual = percentualStatus.percentual;
  }

  modeloCompleto(): boolean {
    return this.descricaoStatusOcorrencia !== undefined && this.percentual !== undefined;
  }

  getNewInstance(object?: any): PercentualStatus {
    return new PercentualStatus(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/percentual-status.ts